import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import DataTableSearchToolbar from './DataTableSearchToolbar';
import SearchIcon from '@material-ui/icons/Search';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

const DataTableToolbarWrapper = styled.div`
  height: 68px;
  display: flex;
  flex-direction: column;
  border-bottom: 2px solid #e0e0e0;
  input {
    border: none;
  }
  input:focus {
    outline: none !important;
  }
  justify-content: center;
  align-items: flex-end;
`;

const DataTableToolbarIcons = styled.div`
   button {
      margin-right: 24px;
   },
   button:last-child {
      margin-right: 10px;
   },
`;

const CheckBoxToolbar = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
  cursor: pointer;
`;

const DataTableToolbar = ({ search = true, fulltextFilter, setFulltextFilter, checkboxLines, customTools, checkboxTools }) => {
  const [buttonsVisible, setButtonsVisible] = useState(true);
  const [searchVisible, setSearchVisible] = useState(false);
  const [checkBoxActionVisible, setCheckBoxActionVisible] = useState(false);

  useEffect(() => {
    if (checkboxLines.length > 0) {
      setSearchVisible(false);
      setButtonsVisible(false);
      setCheckBoxActionVisible(true);
    } else {
      setSearchVisible(false);
      setButtonsVisible(true);
      setCheckBoxActionVisible(false);
    }
  }, [checkboxLines]);

  return (
    <DataTableToolbarWrapper>
      {searchVisible && search && (
        <DataTableSearchToolbar
          onClose={() => {
            setSearchVisible(false);
            setButtonsVisible(true);
            setFulltextFilter('');
          }}
          onChange={(text) => setFulltextFilter(text)}
          value={fulltextFilter}
        />
      )}
      {buttonsVisible && (
        <DataTableToolbarIcons key={'toolbar-search'}>
          {search && (
            <Tooltip title={<FormattedMessage id={'app.dataTable.toolbarIconTooltip.find'} />} arrow>
              <IconButton
                size={'small'}
                onClick={() => {
                  setSearchVisible(true);
                  setButtonsVisible(false);
                }}>
                <SearchIcon fontSize={'large'} />
              </IconButton>
            </Tooltip>
          )}
          {customTools}
        </DataTableToolbarIcons>
      )}

      {checkBoxActionVisible && (
        <DataTableToolbarIcons key={'toolbar-download'}>
          {checkboxTools.map((tool, index) => (
            <CheckBoxToolbar key={index}>
              <IconButton size={'small'} onClick={() => tool.onClick && tool.onClick(checkboxLines)}>
                {tool.icon}
              </IconButton>
              <span onClick={() => tool.onClick && tool.onClick(checkboxLines)}>{tool?.label ? tool.label : ''}</span>
            </CheckBoxToolbar>
          ))}
        </DataTableToolbarIcons>
      )}
    </DataTableToolbarWrapper>
  );
};

DataTableToolbar.propTypes = {
  search: PropTypes.bool,
  customTools: PropTypes.node,
  checkboxTools: PropTypes.array,
  fulltextFilter: PropTypes.string,
  setFulltextFilter: PropTypes.func,
  checkboxLines: PropTypes.array,
};

export default DataTableToolbar;
